/**
 * Custom Collection section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-collection.liquid. The homepage renders three
 * instances of that section, and each one previously inlined this same ~185
 * line script, so the markup carried three near-identical copies.
 *
 * This version initialises every instance on the page instead of being bound to
 * one section id, so the file is fetched and parsed once regardless of how many
 * instances are rendered. Initialisation is idempotent - an element that has
 * already been wired is skipped - which keeps repeat calls (and the theme
 * editor's shopify:section:load) safe.
 */
(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.customCollectionInit === 'true') return;
    sectionEl.dataset.customCollectionInit = 'true';


    const track = sectionEl.querySelector('.custom-collection__track');
    const prevBtn = sectionEl.querySelector('.custom-collection__arrow--prev');
    const nextBtn = sectionEl.querySelector('.custom-collection__arrow--next');

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollDistance() {
      const slide = track.querySelector('.custom-collection__slide');
      return slide ? slide.offsetWidth + 6 : 320;
    }

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
    });

    // Quick size button click handler with event delegation
    sectionEl.addEventListener('click', async function (e) {
      const btn = e.target.closest('.custom-collection__size-box');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled || btn.classList.contains('is-soldout')) {
        return;
      }

      if (btn.classList.contains('is-loading')) {
        return;
      }

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        const card = btn.closest('.custom-collection__card');
        const link = card ? card.querySelector('.custom-collection__media-link') : null;
        if (link) window.location.href = link.href;
        return;
      }

      btn.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          btn.classList.remove('is-loading');
          alert(errData.description || errData.message || 'Unable to add this item to cart.');
          return;
        }

        const addedItem = await response.json();

        // Fetch fresh full cart from Shopify
        const cartResponse = await fetch('/cart.js');
        const fullCart = await cartResponse.json();

        // Visual feedback on button
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(() => {
          btn.classList.remove('is-added');
        }, 1200);

        // Update header cart bubbles across the entire page immediately
        const newCount = fullCart.item_count;
        const cartBubbles = document.querySelectorAll('.custom-header__cart-bubble, [data-cart-count]');
        cartBubbles.forEach(bubble => {
          bubble.textContent = newCount;
          if (newCount > 0) {
            bubble.classList.add('is-visible');
            bubble.classList.remove('has-pulse');
            void bubble.offsetWidth;
            bubble.classList.add('has-pulse');
          } else {
            bubble.classList.remove('is-visible');
          }
        });

        // Dispatch theme standard and custom events
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: addedItem, cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('cart:open'));

      } catch (error) {
        btn.classList.remove('is-loading');
        console.error('Error adding to cart:', error);
        const card = btn.closest('.custom-collection__card');
        const link = card ? card.querySelector('.custom-collection__media-link') : null;
        if (link) window.location.href = link.href + '?variant=' + variantId;
      }
    });

    // ================= WISHLIST TOGGLE & STORAGE =================
    function getWishlist() {
      try {
        const stored = localStorage.getItem('gym_wishlist');
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        return [];
      }
    }

    function setWishlist(list) {
      try {
        localStorage.setItem('gym_wishlist', JSON.stringify(list));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list, count: list.length } }));
    }

    function syncWishlistButtons() {
      const list = getWishlist();
      const wishlistBtns = sectionEl.querySelectorAll('.custom-collection__wishlist-btn');
      wishlistBtns.forEach(btn => {
        const handle = btn.getAttribute('data-product-handle');
        if (handle && list.includes(handle)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-label', 'Remove from wishlist');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-label', 'Add to wishlist');
        }
      });
    }

    const wishlistBtns = sectionEl.querySelectorAll('.custom-collection__wishlist-btn');
    wishlistBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.getAttribute('data-product-handle');
        if (!handle) return;

        let list = getWishlist();
        const index = list.indexOf(handle);
        if (index > -1) {
          list.splice(index, 1);
          btn.classList.remove('is-active');
        } else {
          list.push(handle);
          btn.classList.add('is-active');
        }
        setWishlist(list);
      });
    });

    syncWishlistButtons();
    document.addEventListener('wishlist:updated', syncWishlistButtons);
    window.addEventListener('storage', syncWishlistButtons);
  }

  var SELECTOR = '[data-section-type="custom-collection"]';

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: a re-rendered section arrives with a fresh element, so the
  // init guard on the old node does not block it.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
